
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report/bushfire",
      function () {
        return require("private-next-pages/report/bushfire.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report/bushfire"])
      });
    }
  